/* import __COLOCATED_TEMPLATE__ from './content.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export default class Content extends Component {
  @service('messenger-settings-service') settingsService;
  @service helpCenterService;
  @service appService;

  get app() {
    return this.appService.app;
  }

  get hasMultipleHelpCenterSites() {
    return this.helpCenterService.sites?.length > 1;
  }

  get layoutAndSpacesTitle() {
    if (this.args.isMobilePlatform) {
      return 'messenger.settings-layout.spaces.title';
    } else {
      return 'messenger.settings-layout.spaces.title';
    }
  }
}
